module.exports = __webpack_public_path__ + "img/img6.c48e3c9d.png";